import React from 'react';
import { Box, Button, ListItemText, Typography } from '@mui/material';
import { useAppDispatch } from '../../../../hooks';
import { closeMobileMenu } from './menuSlice';
import useTranslations from '../../../global/translation/hooks/translation';
import { scrollFn } from '../helper';
import { useThemeContext } from '../../../global/ThemeContext';
import { setLanguage } from '../../../global/translation/translationSlice';
import DarkModeToggle from '../../DarkModeToggle';

const MobileMenuLinks = () => {
  const { currentLanguage, translations } = useTranslations();
  const dispatch = useAppDispatch();
  const { darkMode } = useThemeContext();
  const navButtonSx = { textTransform: 'none' };

  const handleCloseNavMenu = () => {
    dispatch(closeMobileMenu());
  };

  const handleMobileLinkClick = (e: React.MouseEvent<HTMLButtonElement>, section: string) => {
    scrollFn(section);
    setTimeout(() => {
      handleCloseNavMenu();
    }, 1000);
  };

  return (
    <>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'about')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.aboutUs[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'offer')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.offer[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'horses')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.horses[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'method')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.method[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'pricing')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.pricing[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'team')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.ourTeam[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>
      <Button fullWidth sx={navButtonSx} onClick={(e) => handleMobileLinkClick(e, 'contact')}>
        <ListItemText>
          <span>
            <Typography sx={{ color: darkMode ? '#FFFFFF' : '#000000' }}>{translations.menuItems.contact[currentLanguage]}</Typography>
          </span>
        </ListItemText>
      </Button>

      {/* CTA Button */}
      <Box sx={{ px: 2, py: 2 }}>
        <Button
          variant="contained"
          fullWidth
          onClick={() => {
            window.location.href = 'https://lubie.urbanequestrian.pl/';
            handleCloseNavMenu();
          }}
          sx={{
            bgcolor: '#1976d2',
            color: '#FFFFFF',
            fontWeight: 600,
            textTransform: 'none',
            py: 1.5,
            borderRadius: '4px',
            boxShadow: 'none',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            '&:hover': {
              bgcolor: '#115293',
              boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
              transform: 'translateY(-2px)',
            },
          }}
        >
          {translations.label.ctaApplyTraining[currentLanguage]}
        </Button>
      </Box>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: '0 0 auto', justifyContent: 'center' }}>
        <DarkModeToggle />
        <Button
          onClick={() => {
            currentLanguage === 'en' ? dispatch(setLanguage('pl')) : dispatch(setLanguage('en'));
          }}
          size="large"
          sx={{ minWidth: 0, px: 2, ml: 1, fontWeight: 600, color: darkMode ? '#FFFFFF' : '#000000', textTransform: 'none', justifyContent: 'left' }}
        >
          {currentLanguage === 'en' ? 'PL' : 'EN'}
        </Button>
      </Box>
    </>
  );
};

export default MobileMenuLinks;
